import React from 'react';
import { Field } from 'react-final-form';

import Checkbox from '../../../Checkbox/Checkbox';
import { fastDepositField } from '../../SavePaymentInfo';

import { TXTWCL_Make_this_my_preferred_payment_ELL } from './SavedCardCheckboxes.messages.json';

interface Props {
  className?: string;
}

const SavedCardCheckboxes: React.FC<Props> = ({ className }) => (
  <Field name={fastDepositField} type="checkbox">
    {({ input: { onChange, checked } }) => (
      <Checkbox
        name={fastDepositField}
        checked={checked}
        onChange={onChange}
        label={TXTWCL_Make_this_my_preferred_payment_ELL}
        className={className}
      />
    )}
  </Field>
);

export default SavedCardCheckboxes;
